import FetchUtils from 'src/utils/fetch_utils';
import DashboardUtils from 'src/utils/dashboard_utils';

/**
 * Fetch dashboard item HTML for the showing and update the dashboard list.
 */
export function refreshDashboardShowing(popup, showingUid, showingId) {
  if (!showingUid || !showingId) {
    return;
  }

  const urlTemplate = popup?.dataset?.dashboardItemUrl;
  if (!urlTemplate) {
    return;
  }
  const url = urlTemplate.replace('__UID__', showingUid);
  FetchUtils.fetchJSON(url)
    .then((response) => {
      if (response?.html) {
        DashboardUtils.updateShowingHtml(`${showingId}`, response.html);
      }
    })
    .catch((err) => {
      FetchUtils.handleResponseError(err);
    });
}
